<app-ice-input-field
  inputWidth="medium"
  label="EAN/GTIN"
  ngDefaultControl
  textTestId="gtin-input"
  [errorText]="getGtinErrorText(gtinControl.errors)"
  [focusOnLoad]="true"
  [forId]="gtinElementId"
  [formControl]="gtinControl"
  [readonly]="isFetchingProductData()"
  (keydown.enter)="onGtinEnter($event)"
/>

<button
  class="open-info-dialog"
  data-testid="open-gtin-info-dialog-button"
  [id]="gtinDialogBtnId"
  (click)="openDialogService.openGtinInfoDialog()"
>
  <mat-icon [svgIcon]="IconNames.ice_info" />
  Slik finner du EAN/GTIN
</button>

@if (showHeadsNotFoundAlert()) {
  <app-ice-alert class="not-found-alert" type="warning">
    Finner ikke produktet, sjekk at EAN/GTIN-koden stemmer. Ordren vil ikke havne i kassasystemet.
  </app-ice-alert>
}

@if (isFetchingProductData()) {
  <app-spinner />
}

@if (shouldDisplayImeiInput) {
  <app-ice-input-field
    inputWidth="medium"
    label="IMEI"
    ngDefaultControl
    textTestId="imei-input"
    [errorText]="getImeiErrorText(imeiControl.errors)"
    [forId]="imeiElementId"
    [formControl]="imeiControl"
    [maxLength]="16"
    [readonly]="isValidatingImei()"
    [selectOnFocus]="true"
    (keydown.enter)="$event.preventDefault()"
  />
  <button
    class="open-info-dialog"
    data-testid="open-imei-info-dialog-button"
    [id]="imeiDialogBtnId"
    (click)="openDialogService.openImeiInfoDialog()"
  >
    <mat-icon [svgIcon]="IconNames.ice_info" />
    Slik finner du IMEI
  </button>
  @if (isValidatingImei()) {
    <app-spinner />
  } @else if (imeiControl.hasError('isImeiUsedBefore')) {
    <app-ice-alert class="duplicate-imei-alert" type="error">
      <div heading>IMEI-nummeret er brukt før</div>
      Det er allerede solgt en telefon med det IMEI-nummeret. Bruk IMEI-nummeret til telefonen kunden skal kjøpe.
    </app-ice-alert>
  }
}
@if (shouldDisplayProductNameInput) {
  <app-ice-input-field
    inputWidth="medium"
    label="Produktnavn"
    ngDefaultControl
    textTestId="product-name-input"
    [forId]="productNameElementId"
    [formControl]="productNameControl"
  />
  <p class="product-not-found-text">
    Fant ikke produktet. Legg inn
    <br />
    produktnavnet her (f.eks {{ isMobilePhoneContext ? 'Google Pixel 8' : 'AirPods Pro' }})
  </p>
}
@if (shouldDisplayMissingIdentifiersCheckbox) {
  <app-ice-checkbox
    class="update-identifiers-later"
    label="Jeg har ikke telefonen tilgjengelig"
    ngDefaultControl
    testId="update-identifiers-later-input"
    [forId]="missingIdentifiersElementId"
    [formControl]="missingIdentifiersControl"
  />
}
